import type { AccessibleSVGProps } from '@core/svg'
import { AccessibleSVG } from '@core/svg'

/**
 * Minimize SVG Icon for minimize widget button.
 */
export const Minimize: React.FC<AccessibleSVGProps> = (props) => (
  <AccessibleSVG
    width="100%"
    height="100%"
    viewBox="0 0 32 32"
    aria-hidden={true}
    {...props}
  >
    <rect
      x="6"
      y="24"
      width="20"
      height="4"
      fill={props.fill ?? 'currentColor'}
    />
  </AccessibleSVG>
)
